import React from "react";
import PropTypes from "prop-types";
import responseTypes from "../../../utils/responseTypes";
import { AccordionSection } from "./AccordionSection";
import { SectionErrors } from "./SectionErrors";
import { RadioQuestion } from "./RadioQuestion";

export function ElectricalSignOffSection({ jobToComplete, electricalSignOffHandler, errorMessage }) {
  const isComplete = jobToComplete.completionDetail.electricalSignOffComplete;
  const cd = jobToComplete.completionDetail;
  const rt = responseTypes();

  return (
    <AccordionSection
      id="electricalSignOff"
      headerId="headerElectricalSignOff"
      collapseId="collapseElectricalSignOff"
      number={5}
      title="Electrical Installation Sign Off"
      isComplete={isComplete}
    >
      <form onSubmit={electricalSignOffHandler}>
        <RadioQuestion
          label="Boiler connected to power supply?"
          name="elecBoilerConnected"
          disabled={isComplete}
          options={[
            { id: "elecBoilerConnectedYes", value: true, label: "Yes", defaultChecked: cd.electricBoilerConnected },
            {
              id: "elecBoilerConnectedNo",
              value: false,
              label: "No",
              defaultChecked: isComplete ? !cd.electricBoilerConnected : "",
            },
          ]}
        />
        <RadioQuestion
          label="Gas correctly bonded (with 600mm) and tightly clamped with a safety label visible?"
          name="gasBonded"
          disabled={isComplete}
          questionColClass="col-xs-12 col-md-6"
          size="sm"
          options={[
            {
              id: "gasBondedYes10mm",
              value: rt.ELECTRIC_BONDED_YES10MM,
              label: "10mm",
              defaultChecked: isComplete && cd.electricBondedAndClamped === rt.ELECTRIC_BONDED_YES10MM,
            },
            {
              id: "gasBondedYes6mm",
              value: rt.ELECTRIC_BONDED_YES6MM,
              label: "6mm",
              defaultChecked: isComplete && cd.electricBondedAndClamped === rt.ELECTRIC_BONDED_YES6MM,
            },
            {
              id: "gasBondedNo",
              value: rt.ELECTRIC_BONDED_NO,
              label: "No",
              defaultChecked: isComplete && cd.electricBondedAndClamped === rt.ELECTRIC_BONDED_NO,
            },
            {
              id: "gasBondedNA",
              value: rt.ELECTRIC_BONDED_NA,
              label: "N/A",
              defaultChecked: isComplete && cd.electricBondedAndClamped === rt.ELECTRIC_BONDED_NA,
            },
          ]}
        />
        <RadioQuestion
          label="Are all cables securely clipped or in trunking where possible?"
          name="cablesClipped"
          disabled={isComplete}
          options={[
            {
              id: "cablesClippedYes",
              value: true,
              label: "Yes",
              defaultChecked: cd.electricClippedAndTrunked,
            },
            {
              id: "cablesClippedNo",
              value: false,
              label: "No",
              defaultChecked: isComplete ? !cd.electricClippedAndTrunked : "",
            },
          ]}
        />
        <RadioQuestion
          label="Electrical connections sleeved (where possible) and their intended use made clear?"
          name="elecSleeved"
          disabled={isComplete}
          options={[
            {
              id: "elecSleevedYes",
              value: true,
              label: "Yes",
              defaultChecked: cd.electricSleevedAndClear,
            },
            {
              id: "elecSleevedNo",
              value: false,
              label: "No",
              defaultChecked: isComplete ? !cd.electricSleevedAndClear : "",
            },
          ]}
        />
        <RadioQuestion
          label="Where is the means of disconnection from the power supply?"
          name="elecDisconnection"
          disabled={isComplete}
          options={[
            {
              id: "elecDisconnectionPlug",
              value: rt.ELECTRIC_DISCONNECT_PLUG,
              label: "Plug",
              defaultChecked: isComplete && cd.electricDisconnection === rt.ELECTRIC_DISCONNECT_PLUG,
            },
            {
              id: "elecDisconnectionSpur",
              value: rt.ELECTRIC_DISCONNECT_SPUR,
              label: "Spur",
              defaultChecked: isComplete && cd.electricDisconnection === rt.ELECTRIC_DISCONNECT_SPUR,
            },
          ]}
        />
        <RadioQuestion
          label="Has the boiler got an earth directly connected to the isolation point (plug/spur)?"
          name="boilerEarth"
          disabled={isComplete}
          options={[
            {
              id: "boilerEarthYes",
              value: true,
              label: "Yes",
              defaultChecked: cd.electricDirectEarthToIsolation,
            },
            {
              id: "boilerEarthNo",
              value: false,
              label: "No",
              defaultChecked: isComplete ? !cd.electricDirectEarthToIsolation : "",
            },
          ]}
        />
        <RadioQuestion
          label="Have heating controls been installed within manufacturers guidelines?"
          name="heatingControls"
          disabled={isComplete}
          options={[
            {
              id: "heatingControlsYes",
              value: rt.ELECTRIC_HEATING_CONTROLS_YES,
              label: "Yes",
              defaultChecked: isComplete && cd.electricHeatingControlsOk === rt.ELECTRIC_HEATING_CONTROLS_YES,
            },
            {
              id: "heatingControlsNo",
              value: rt.ELECTRIC_HEATING_CONTROLS_NO,
              label: "No",
              defaultChecked: isComplete && cd.electricHeatingControlsOk === rt.ELECTRIC_HEATING_CONTROLS_NO,
            },
            {
              id: "heatingControlsNA",
              value: rt.ELECTRIC_HEATING_CONTROLS_NA,
              label: "N/A",
              defaultChecked: isComplete && cd.electricHeatingControlsOk === rt.ELECTRIC_HEATING_CONTROLS_NA,
            },
          ]}
        />
        <RadioQuestion
          label="Has the customer been shown how to operate the heating controls?"
          name="heatingControlsDemo"
          disabled={isComplete}
          options={[
            {
              id: "heatingControlsDemoYes",
              value: rt.ELECTRIC_HEATING_CONROLS_DEMO_YES,
              label: "Yes",
              defaultChecked:
                isComplete && cd.electricCustomerShownHeatingControls === rt.ELECTRIC_HEATING_CONROLS_DEMO_YES,
            },
            {
              id: "heatingControlsDemoNo",
              value: rt.ELECTRIC_HEATING_CONROLS_DEMO_NO,
              label: "No",
              defaultChecked:
                isComplete && cd.electricCustomerShownHeatingControls === rt.ELECTRIC_HEATING_CONROLS_DEMO_NO,
            },
            {
              id: "heatingControlsDemoNA",
              value: rt.ELECTRIC_HEATING_CONROLS_DEMO_NA,
              label: "N/A",
              defaultChecked:
                isComplete && cd.electricCustomerShownHeatingControls === rt.ELECTRIC_HEATING_CONROLS_DEMO_NA,
            },
          ]}
        />
        <div className="d-flex flex-column flex-md-row justify-content-md-end gap-2 mt-2" id="submitElectricalSignOff">
          <button
            onClick={electricalSignOffHandler}
            type="submit"
            className="btn btn-primary"
            disabled={isComplete}
          >
            Submit Electrical Sign Off
          </button>
        </div>
        <SectionErrors errorMessage={errorMessage} section="electricalSignOff" />
      </form>
    </AccordionSection>
  );
}

ElectricalSignOffSection.propTypes = {
  jobToComplete: PropTypes.object.isRequired,
  electricalSignOffHandler: PropTypes.func.isRequired,
  errorMessage: PropTypes.array.isRequired,
};
